import React from 'react'
import { Embroidery, EmbroideryKey, EmbroideryObjects, PartialAction, PartialShoesAction } from 'src/types'

type ObjectKey = {
  typeFace: string
  position: string
  color: string
  shadowColor: string
  edgeColor: string
}

const SET_EMBROIDERIES = 'setEmbroideries'
const embroideriesReducer = (embroideries: Embroidery[], newEmbroideries: Embroidery, i: number): Embroidery[] => {
  return embroideries.reduce((a: Embroidery[], c) => {
    if (c.id === i) a.push(newEmbroideries)
    if (c.id !== i) a.push(c)
    return a
  }, [])
}

const updateEmbroideries = (
  embroideries: Embroidery[],
  objects: EmbroideryObjects,
  selected: string,
  type: EmbroideryKey,
  i: number
): Embroidery[] => {
  const objectKey = type as keyof ObjectKey
  const newEmbroideries = {
    ...embroideries[i],
    [type]: objects[objectKey].filter((prev) => prev.value === selected)[0]
  }
  return embroideriesReducer(embroideries, newEmbroideries, i)
}

export const useEmbroideriesDispatcher = (
  dispatch: React.Dispatch<PartialAction | PartialShoesAction>,
  embroideries: Embroidery[],
  selected: string,
  objects: EmbroideryObjects,
  key: EmbroideryKey,
  i?: number | undefined
): void => {
  if (i === undefined) return
  dispatch({
    type: SET_EMBROIDERIES,
    embroideries: updateEmbroideries(embroideries, objects, selected, key, i)
  })
}
